export const ROOM_RATE_CONFIGURATION_FORM_NAME = 'roomRateConfigurationForm';
export const MULTI_ROOM_RATE_CONFIGURATION_FORM_NAME = 'multiRoomRateConfigurationForm';

export const roomRateBookingFormConfig = {
  form: ROOM_RATE_CONFIGURATION_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: false,
};

export const multiRoomRateBookingFormConfig = {
  form: MULTI_ROOM_RATE_CONFIGURATION_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: false,
};
